import React, { memo, useEffect, useRef, useState } from "react";
import styles from "./StoreSearch.module.scss";
import { SearchIcon } from "../../../../assets/icons";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useLazySearchByNameQuery } from "../../../../service/solar-product-service";

type Props = {
};

const StoreSearch: React.FC<Props> = memo((props: Props) => {
	const [search, setSearch] = useState<string>('');
    const [debouncedSearch, setDebouncedSearch] = useState<string>('');
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const dropdownRef = useRef<HTMLDivElement | null>(null);
	const navigate = useNavigate();

	const [searchProducts, { data: searchedSolarProducts, isLoading, error }] = useLazySearchByNameQuery();

	const handleClickOutside = (event: MouseEvent) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
		  setIsOpen(false);
		}
	  };

	const changeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value)
		setIsOpen(false);
    }

	useEffect(() => {
		// Attach the click event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
		  // Clean up the event listener
		  document.removeEventListener('mousedown', handleClickOutside);
		};
	  }, []);

	useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search])

	useEffect(() => {
        if (debouncedSearch) {
            searchProducts(debouncedSearch);
        }
    }, [debouncedSearch, searchProducts]);


	useEffect(() => {
        if (searchedSolarProducts && searchedSolarProducts.length > 0) {
            setIsOpen(true);
        }
    }, [searchedSolarProducts]);

    useEffect(() => {
        if (error) {
            toast.error('There was an error searching Solar Products');
        }
    }, [error]);
	
	return (
		<div className={styles.container}>
            <SearchIcon />
			<div className={styles.searchAndDropdown}>
				<input type="text" placeholder="Find the package that fits you" className={styles.searchInput} onChange={changeSearch} onFocus={() => setIsOpen(true)}/>
				{
					isOpen && searchedSolarProducts && searchedSolarProducts.length > 0 &&
					<div className={styles.dropdownMenu} ref={dropdownRef} >
						{searchedSolarProducts.map(x => 
							<div key={x.id} className={styles.menuItem} onClick={() => {setIsOpen(false); navigate(`/store/item/${x.id}`); }}>
								{x.productName}
							</div>
						)}
					</div>
				} 
			</div>
			<button className={`standardButton ${styles.searchButton}`}>Search</button>
		</div>
	);
});

export default StoreSearch;
